import { MutationTree } from "vuex";
import { FACTURA } from "./types";

type FacturasMutationTree = MutationTree<FACTURA>;

export const mutations: FacturasMutationTree = {};
